export default "__VITE_ASSET__CPiH_6r$__"